import { activity } from './activity';
import { enumItems } from './enumItems';
import { driver } from './driver';
import { statuses } from './statuses';
import { group } from './group';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { Group } from '../types/entities/Group';
import { Activity } from '../types/entities/Activity';
import { NumberField } from '../components/Table/fields/NumberField';
import { SelectField } from '../components/Table/fields/SelectField';
import { DateField } from '../components/Table/fields/DateField';
import { TimeField } from '../components/Table/fields/TimeField';
import { TextField } from '../components/Table/fields/TextField';
import { SetField } from '../components/Table/fields/SetField';
import { salesPartner } from './salesPartner';
import { address } from './address';
import { RichTextField } from '../components/Table/fields/RichTextField';
import { SelectFieldWithoutAutocomplete } from '../components/Table/fields/SelectFieldWithoutAutocomplete';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import { SPTimeField } from '../components/Table/fields/SPTimeField';
import { SPRichTextField } from '../components/Table/fields/SPRichTextField';
import { SPNumberField } from '../components/Table/fields/SPNumberField';
import { SPDateField } from '../components/Table/fields/SPDateField';
import { userByRole } from './userByRole';
import { ServiceReservation } from '../components/ActivityReservations/ServiceReservation';
import { SPCustomSetFieldForGuideReservation } from '../components/Table/fields/SPCustomSetFieldForGuideReservation';
import { ActivityReservationFinance } from '../components/LegalAndFinance/ActivityReservationFinance';
import { SPListField } from '../components/Table/fields/SPListField';
import { SPDateTimeField } from '../components/Table/fields/SPDateTimeField';
import { SelectAddressField } from '../components/Table/fields/SelectAddressField';
import { Finance } from '../components/ActivityReservations/Finance';
import {ServiceReservationView} from "../components/ActivityReservations/ServiceReservationView";
import {SPStatusField} from "../components/Table/fields/SPStatusField";
import {SPSelectVenueAddressField} from "../components/Table/fields/SPSelectVenueAddressField";
import {SPSetUserField} from "../components/Table/fields/SPSetUserField";
import {BooleanField} from "../components/Table/fields/BooleanField";
import {SPBooleanField} from "../components/Table/fields/SPBooleanField";
import {SPSetField} from "../components/Table/fields/SPSetField";
import {user} from "./user";

export const activityReservationMinimal = (
  forGroupId?: Group['id'],
  forActivityId?: Activity['id']
): SchemaWithClient<any> => {
  return {
    name: 'Activity Reservation',
    pluralName: 'Activity Reservations',
    columns: {
      type: {
        name: 'Type',
        fieldRenderer: SelectField.tableAdapter(enumItems.serviceReservationType),
        slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.serviceReservationType),
        switchboard: true,
        url: enumItems.serviceReservationType.client.getAllPath,
        tempSchema: enumItems.serviceReservationType,
      },
      activity: {
        name: 'Activity Name',
        required: true,
        fieldRenderer: SelectField.tableAdapter(activity),
        slidePaneFieldRenderer: SPSelectField.tableAdapter(activity),
        switchboard: true,
        url: activity.client.getAllPath,
        tempSchema: activity,
        hideInTableView: true,
      },
      sales_partner: {
        name: 'Sales Partner',
        fieldRenderer: SelectField.tableAdapter(enumItems.salesPartner),
        slidePaneFieldRenderer: SPSelectField.tableAdapter(
          enumItems.salesPartner
        ),
        switchboard: true,
        required: true,
        url: enumItems.salesPartner.client.getAllPath,
        tempSchema: enumItems.salesPartner,
      },
      date: {
        name: 'Date',
        fieldRenderer: DateField,
        slidePaneFieldRenderer: SPDateField,
        fieldType: 'date',
        required: true,
      },
      pickup_time: {
        name: 'Pickup',
        fieldRenderer: TimeField,
        slidePaneFieldRenderer: SPTimeField,
        fieldType: 'time',
      },
      start_time: {
        name: 'Start',
        fieldRenderer: TimeField,
        slidePaneFieldRenderer: SPTimeField,
        fieldType: 'time',
      },
      group: {
        name: 'Group',
        fieldRenderer: SelectField.tableAdapter(group),
        slidePaneFieldRenderer: SPSelectField.tableAdapter(group),
        switchboard: true,
        readOnly: true,
        url: group.client.getAllPath,
        tempSchema: group,
      },
      group_size: {
        name: 'Size',
        fieldRenderer: NumberField,
        slidePaneFieldRenderer: SPNumberField,
        fieldType: 'number',
      },
    },
    client: new Client(
      '/activity-reservations',
      forGroupId !== undefined
        ? `/groups/${forGroupId}/activity-reservations`
        : undefined
    ),
    viewTable: 'activity_reservations',
  };
};
